import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const messages = {
  zh: {
    login: "登录",
    trial: "预约演示",
    heroTag: "跨境业务数字化",
    heroTitle: "让跨境业务更高效、更智能",
    heroDescLine1: "为跨境电商与跨境仓储企业提供一体化数字解决方案",
    heroDescLine2: "覆盖 OMS / WMS / ERP / DRP / BI，全链路赋能业务增长",
    heroCtaDemo: "预约演示",
    heroCtaProducts: "了解产品",
    products: "核心产品",
    productsLead: "我们提供覆盖跨境业务全流程的系统产品矩阵，帮助企业实现一体化管理与高效协同。",
    productsPageTitle: "产品介绍",
    productAdvantageTitle: "产品优势总结",
    productAdvantage1: "系统一体化（无需多系统拼接）",
    productAdvantage2: "高可扩展架构（支持业务增长）",
    productAdvantage3: "灵活定制（适配不同业务模式）",
    productAdvantage4: "稳定高性能（支持大规模订单）",
    partners: "合作伙伴",
    contact: "联系我们",
    preSales: "售前",
    afterSales: "售后",
    email: "邮箱",
    address: "地址",
    qrCaptionContact: "扫码获取专业服务",
    qrCaptionWechat: "扫码了解最新动态",
    preSalesConsult: "售前咨询电话",
    afterSalesConsult: "售后咨询电话",
    copyrightMark: "版权所有"
  },
  en: {
    login: "Login",
    trial: "Book a demo",
    heroTag: "Cross-border digital",
    heroTitle: "Make cross-border business smarter and more efficient",
    heroDescLine1: "Integrated digital solutions for cross-border e‑commerce and warehousing",
    heroDescLine2: "OMS / WMS / ERP / DRP / BI — full-chain enablement for growth",
    heroCtaDemo: "Book a demo",
    heroCtaProducts: "Explore products",
    products: "Products",
    productsLead:
      "A full product matrix covering the cross-border lifecycle — unified management and collaboration.",
    productsPageTitle: "Products",
    productAdvantageTitle: "Why choose us",
    productAdvantage1: "Unified stack without stitching multiple systems",
    productAdvantage2: "Highly scalable architecture for growth",
    productAdvantage3: "Flexible customization for different business models",
    productAdvantage4: "Stable, high performance at scale",
    partners: "Partners",
    contact: "Contact Us",
    preSales: "Pre-sales",
    afterSales: "After-sales",
    email: "Email",
    address: "Address",
    qrCaptionContact: "Scan for professional service",
    qrCaptionWechat: "Scan for updates",
    preSalesConsult: "Pre-sales hotline",
    afterSalesConsult: "After-sales hotline",
    copyrightMark: "All rights reserved"
  },
  th: {
    login: "เข้าสู่ระบบ",
    trial: "นัดสาธิต",
    heroTag: "ดิจิทัลข้ามพรมแดน",
    heroTitle: "ทำให้ธุรกิจข้ามพรมแดนฉลาดและมีประสิทธิภาพยิ่งขึ้น",
    heroDescLine1: "โซลูชันดิจิทัลแบบบูรณาการสำหรับอีคอมเมิร์ซและคลังสินค้าข้ามพรมแดน",
    heroDescLine2: "ครอบคลุม OMS / WMS / ERP / DRP / BI — เชื่อมโยงทั้งสายธุรกิจ",
    heroCtaDemo: "นัดสาธิต",
    heroCtaProducts: "ดูผลิตภัณฑ์",
    products: "ผลิตภัณฑ์",
    productsLead: "ชุดผลิตภัณฑ์ครอบคลุมกระบวนการข้ามพรมแดน — บริหารและทำงานร่วมกันแบบบูรณาการ",
    productsPageTitle: "ผลิตภัณฑ์",
    productAdvantageTitle: "จุดเด่น",
    productAdvantage1: "ระบบรวม ไม่ต้องประกอบหลายชุด",
    productAdvantage2: "สถาปัตยกรรมขยายได้ตามการเติบโต",
    productAdvantage3: "ปรับแต่งยืดหยุ่นตามรูปแบบธุรกิจ",
    productAdvantage4: "เสถียรและประสิทธิภาพสูงในระดับใหญ่",
    partners: "พาร์ทเนอร์",
    contact: "ติดต่อเรา",
    preSales: "ก่อนการขาย",
    afterSales: "หลังการขาย",
    email: "อีเมล",
    address: "ที่อยู่",
    qrCaptionContact: "สแกนเพื่อบริการ",
    qrCaptionWechat: "สแกนข่าวสารล่าสุด",
    preSalesConsult: "โทรก่อนขาย",
    afterSalesConsult: "โทรหลังขาย",
    copyrightMark: "สงวนลิขสิทธิ์"
  }
};

export default new VueI18n({
  locale: "zh",
  fallbackLocale: "en",
  messages
});
